module.exports = __webpack_public_path__ + "img/1506436008.15307462.jpg";